const { eposStore } = require('@/epos/vue/stores/eposStore');

/**
 * Before PROP-539 this was a class that stored the search results from the order search page.
 * But in that task the search page was refactored to use Vue and cache the results in Vuex.
 * What we have here now are some functions to interface with the Vuex order search results cache.
 */

/**
 * @param {string|number} refOrID
 *
 * @return {Order|null}
 */
const getOrderFromSearchCache = (refOrID) => {
    /**
     * @type {OrderSearchResults|null}
     */
    const results = eposStore.state.orderSearch.results;
    if (!results) {
        return null;
    }

    const orderID = parseInt(refOrID, 10);

    return results.orders.find((order) => order.bookingRef === refOrID || order.ID === orderID) || null;
};

/**
 * Clear the results in the order search cache, as well as the form details that were searched for.
 */
const clearOrderSearchCache = () => {
    eposStore.commit('orderSearch/clear', false);
};

/**
 * Mark the results in the cache as no longer valid. This does not remove any data from the cache
 * but it tells the order search page that it should redo its search (with the same form data) the
 * next time it is opened.
 */
const invalidateOrderSearchCache = () => {
    eposStore.commit('orderSearch/setResultsValid', false);
};

/**
 * If a specific session was searched for on the order search page, there will
 * be a redeem button shown on each order in the results.
 * When we (un)redeem something here it will not be reflected in the redemption
 * counts on those buttons. So in that case, mark the data as invalid so that the
 * order search page re-searches when it is returned to and the data is updated.
 */
const invalidateOrderSearchCacheOnRedemption = () => {
    if (eposStore.state.orderSearch.form && eposStore.state.orderSearch.form.sessionWithEvent) {
        invalidateOrderSearchCache();
    }
};

module.exports = {
    clearOrderSearchCache,
    getOrderFromSearchCache,
    invalidateOrderSearchCache,
    invalidateOrderSearchCacheOnRedemption,
};
